import React from 'react';
import { DefaultButton } from '../Button/Default';
import { PrimaryButton } from '../Button/Primary';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const FiltersButtons = _ref => {
  let {
    selectedHiddenFiltersCount,
    areFiltersHidden,
    searchButtonProps,
    clearFiltersButtonProps,
    toggleVisibilityButtonProps
  } = _ref;
  const getToggleFiltersVisibilityButtonText = () => {
    return areFiltersHidden ? "Show filters (".concat(selectedHiddenFiltersCount, " ").concat(selectedHiddenFiltersCount === 1 ? 'filter' : 'filters', " selected)") : "Hide filters (".concat(selectedHiddenFiltersCount, " ").concat(selectedHiddenFiltersCount === 1 ? 'filter' : 'filters', " selected)");
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DefaultButton, {
      text: getToggleFiltersVisibilityButtonText(),
      onClick: toggleVisibilityButtonProps.onClick,
      disabled: toggleVisibilityButtonProps.isDisabled,
      "data-id": toggleVisibilityButtonProps.dataId,
      styles: toggleVisibilityButtonProps.styles
    }), /*#__PURE__*/_jsx(DefaultButton, {
      text: "Clear filters",
      onClick: clearFiltersButtonProps.onClick,
      disabled: clearFiltersButtonProps.isDisabled,
      "data-id": clearFiltersButtonProps.dataId,
      styles: clearFiltersButtonProps.styles
    }), /*#__PURE__*/_jsx(PrimaryButton, {
      text: "Search",
      onClick: searchButtonProps.onClick,
      disabled: searchButtonProps.isDisabled,
      "data-id": searchButtonProps.dataId,
      styles: searchButtonProps.styles
    })]
  });
};